import { ActionListModel } from "@genexus/chameleon-controls-library";

export const mapCommentsToActionListModel = (
  comments: string[]
): ActionListModel => {
  return comments.map(comment => {
    return {
      id: comment,
      type: "actionable",
      caption: comment
    };
  });
};

